import React, { useMemo, useEffect } from 'react';
import { Route, Switch, useLocation, useRouteMatch, Redirect, Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import qs from 'qs';
import General from './General';
import Providers from './Providers';
import Payments from './Payments';
import Modules from './Modules';
import Integrations from './Integrations';
import Notifications from './Notifications';
import Bonuses from './Bonuses';
import Signup from './Signup';
import NewTicket from './NewTicket';

import { getSettingsConfigAction } from '../../redux/actions/settings';
import { settingsSelector } from '../../redux/selectors/settings';
import Loader from '../../components/Loaders/Loader';

const routesComponents = {
  General: [
    {
      code: 'general',
      exact: true,
      component: General,
      to: '/settings',
      alias: ['/settings'],
    },
  ],
  Providers: [
    {
      code: 'providers',
      component: Providers,
      to: '/settings/providers',
      alias: ['/settings/providers'],
    },
  ],
  Payments: [
    {
      code: 'payments',
      component: Payments,
      to: '/settings/payments',
      alias: ['/settings/payments'],
    },
  ],
  Modules: [
    {
      code: 'modules',
      component: Modules,
      to: '/settings/modules',
      alias: ['/settings/modules'],
    },
  ],
  Bonuses: [
    {
      code: 'bonuses',
      component: Bonuses,
      to: '/settings/bonuses',
      alias: ['/settings/bonuses'],
    },
  ],
  Notifications: [
    {
      code: 'notifications',
      component: Notifications,
      to: '/settings/notifications',
      alias: ['/settings/notifications'],
    },
  ],
  Integrations: [
    {
      code: 'integrations',
      component: Integrations,
      to: '/settings/integrations',
      alias: ['/settings/integrations'],
    },
  ],
  'Signup form': [
    {
      code: 'signup',
      component: Signup,
      to: '/settings/signup-form',
      alias: ['/settings/signup-form'],
    },
  ],
  'Ticket form': [
    {
      code: 'ticket_form',
      component: NewTicket,
      to: '/settings/ticket-form',
      alias: ['/settings/ticket-form'],
    },
  ],
};

const Settings = () => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();

  const queryString = qs.parse(location.search.slice(1));

  const reports = useSelector((state) => settingsSelector(state));
  const { isLoadingConfig, mainConfig: config } = reports;

  const routes = useMemo(
    () => config?.menu?.reduce((acc, item) => {
      const compRoutes = routesComponents[item.title];
      if (compRoutes) {
        return [...acc, ...compRoutes];
      }
      return acc;
    }, []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config, url],
  );

  useEffect(() => {
    dispatch(getSettingsConfigAction(queryString));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid className="settings">
      {isLoadingConfig ? (
        <Loader />
      ) : (
        <Row>
          <Col md={2} mdOffset={1}>
            <ul className="p-b nav nav-pills nav-stacked page-tabs">
              {config?.menu?.map((route) => {
                const getComponent = routesComponents[route.title];
                const isActive = getComponent?.[0]?.alias?.some((p) => p === location.pathname);
                return (
                  <li
                    key={route.title}
                    title={route.title}
                    className={classNames('', {
                      active: isActive,
                    })}
                  >
                    <Link to={route.url?.replace('admin/', '')}>{route.title}</Link>
                  </li>
                );
              })}
            </ul>
          </Col>

          <Col md={8}>
            <Switch>
              {routes?.map((route) => (
                <Route key={route.code} exact={route.exact} path={route.to}>
                  <route.component />
                </Route>
              ))}
              {routes?.length ? <Redirect to={routes?.[0]?.to} /> : null}
            </Switch>
          </Col>
        </Row>
      )}
    </Grid>
  );
};

export default Settings;
